module.exports = __webpack_public_path__ + "static/hero-recruit-mobile-36ea252c7ccbaf44af9711824efdfe5a.png";